import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { JokerButton, ButtonType } from "material-ui-jokerpro";
import animationData from "./../../assets/lottie/MouseScrollDown.json";
import Lottie from "react-lottie";
import { useTranslation } from "react-i18next";
import TwoToneHeading from "../../components/TwoToneHeading";
import AssetsPack from "../../util/AssetsPack.js";

import styles from "./MainSection.module.css";
import Paragraph, { ParagraphSize } from "../../components/Paragraph";
import { useNavigate } from "react-router-dom";
import AutoPlayMutedVideo from "../../components/AutoPlayMutedVideo";
import { MOBILE_MAX_WIDTH_PX } from "../../util/Constant";

interface MainSectionProps {}

const MainSection: React.FC<MainSectionProps> = ({}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < MOBILE_MAX_WIDTH_PX
  );
  const size = 40;
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };

  const containerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_MAX_WIDTH_PX);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) return;
    const container = containerRef.current;
    gsap.set(container, { scale: 1.2, transformOrigin: "top" });

    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY < 100) {
        gsap.to(container, { scale: 1.2, duration: 0.8 });
      } else if (scrollY >= 100 && scrollY < 300) {
        gsap.to(container, { scale: 1, duration: 0.8 });
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={styles["main-container"]} ref={containerRef}>
      <div className={styles["inner-container"]}>
        <div className={styles["right-ball"]}></div>
        <div className={styles["top-left-ball"]}></div>
        <div className={styles["bottom-middle-ball"]}></div>

        <div className={styles["logo-container"]}>
          <AutoPlayMutedVideo
            videoSrc={AssetsPack.videos.JOKER_PRO_LOGO_VIDEO}
            classNameStyle={styles["logo-video"]}
          />
        </div>
        <div className={styles["info-container"]}>
          <TwoToneHeading
            primaryText={t("main_section.joker")}
            secondaryText={t("main_section.plus")}
            isOneLine
          />
          <div className={styles["sub-container"]}>
            <Paragraph
              size={ParagraphSize.paragraph1}
              classNameStyle={styles["sub-container"]}
            >
              {t("main_section.subtitle")}
            </Paragraph>
          </div>
          <div className={styles["buttons-container"]}>
            <JokerButton
              text={t("main_section.download")}
              type={ButtonType.CTA}
              onClick={() => navigate("/joker_pro")}
              icon={AssetsPack.icons.ICON_GO.default}
              animated
            />
            {/* <JokerButton
              size={ButtonSize.Medium}
              text={t("main_section.download")}
              type={ButtonType.Text}
              icon={AssetsPack.icons.ICON_GO.default}
              onClick={() => navigate("/download")}
            /> */}
          </div>
        </div>
        <div className={styles["scroll-indicator"]}>
          <Lottie options={defaultOptions} height={size} width={size} />
        </div>
      </div>
    </div>
  );
};

export default MainSection;
